import { DateRangeInput as DateRangePickerBP } from "@blueprintjs/datetime";
import * as moment from "moment";
import * as React from "react";
import MomentLocaleUtils from "react-day-picker/moment";
import { toast } from "react-toastify";
import { getMomentFormatter } from "../../utils";

interface DateRangePicker10Props {
  onChange: (val: any) => void;
  value: any;
}

interface DateRangePicker10State {
  toastShown: boolean
}

export class DateRangePicker10 extends React.Component<DateRangePicker10Props, DateRangePicker10State>{

  constructor(props) {
    super(props)

    this.state = {
      toastShown: false
    };
  }

  validaMes = (date) => {
    let minDate = moment(date[0]).unix()
    let maxDate = moment(date[1]).unix()
    let mes = maxDate - minDate

    if(Number.isNaN(mes)) return false

    if (mes <= 864000) {
      return true

    } else {

      if (!this.state.toastShown) {

        toast.warning('Período máximo de 10 dias!', {});

        this.setState({ toastShown: true })

        setTimeout(() => {
          this.setState({ toastShown: false })
        }, 3000);

      }
      return false;
    }
  }

  handleValidaMeses(date) {
    if (this.validaMes(date)) {
      this.props.onChange([date[0], date[1]])
    } else {
      this.props.onChange([date[0], null])
    }
  }

  render() {
    let dayPickerProps = {
      localeUtils: MomentLocaleUtils,
      locale: "pt-br",
    };

    return (
      <DateRangePickerBP
        {...getMomentFormatter("DD/MM/YYYY")}
        locale="pt-br"
        localeUtils={MomentLocaleUtils}
        dayPickerProps={dayPickerProps}
        placeholder="DD/MM/AAAA"
        shortcuts={false}
        allowSingleDayRange={true}
        value={this.props.value}
        onChange={newDate => this.handleValidaMeses([newDate[0], newDate[1]])}
        startInputProps={{ placeholder: "Data inicial" }}
        endInputProps={{ placeholder: "Data final" }}
      />
    );
  }

}